module.exports = __webpack_public_path__ + "img/map.d3bb26f5.jpg";